import React from 'react';

const About = () => {
    return (
      /* About Section */
      <div className="my-4">
        <h2>Our Mission</h2>
        <p className="fs-4">Our Online education platform will help you to develop  <br /> your technical skill.You can build your carrier by learning these things.<br /> And it will be very helpful for your job. And this is our mission</p>
        <h2>Our Vision</h2>
        <p className="fs-4">Our vision is to helping you to reach your goal.You will enroll our course and then <br /> we will show you the way how you will complete it how you can achieve your goal <br /> and how you will use your proper time. 
        </p>
      </div>
    );
};

export default About;